import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { useSelector, useDispatch } from 'react-redux'
import { messengerActions } from 'srcReact/MessengerPage'

export default function EmptyConversation({ handleClick }) {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isMobile }
  } = useSelector((state) => state)

  const createConversation = () => {
    if (handleClick) {
      handleClick()
    } else {
      dispatch(messengerActions.setSideBarScreenType('create'))
      if (isMobile) {
        dispatch(messengerActions.showSidebar(true))
        dispatch(messengerActions.showMainContent(false))
      }
    }
  }

  return (
    <div className={styles.container}>
      <img className={styles.image} src={`${config.assetUrl}/images/people_33.png`} alt='' />
      <h1 className={styles.message}>{t('messenger.chatWindow.noConversation')} </h1>
      <Button
        customStyle={styles.button}
        handleClick={createConversation}
        size='large'
        text={t('messenger.startConversationButton')}
      />
    </div>
  )
}
